<template>
  <v-layout class="count-box" ml-2 mr-2>
    <v-flex text-center class="display-18-16 fav-title">
      <span class="black--text">{{ title }}</span>
    </v-flex>
    <v-flex text-center class="counter">
      <span class="black--text">{{ counter }}</span>
    </v-flex>
    <v-flex text-center class="display-14 count-footer white--text mob-none">
      <span class="d-block pointer">{{ linkTitle }}</span>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    counter: {
      type: [String, Number],
      default: 0,
    },
    title: {
      type: String,
      default: '',
    },
    linkTitle: {
      type: String,
      default: '',
    },
    items: {
      type: [Object, Array],
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.count-box {
  width: 158px;
  height: auto;
  border-radius: 5px;
  border: solid 1px $primary;
  background-color: #f6f7f9;
  flex-direction: row;
  align-items: baseline;
}

.count-footer {
  background-color: $primary;
}

.fav-title span {
  line-height: 2.2;
}
.mob-none {
  display: none;
}

.counter {
  font-size: 16px;
}
@media only screen and (min-width: 600px) {
  .counter {
    font-size: 36px;
  }
  .mob-none {
    display: block;
  }

  .count-box {
    width: 250px;
    height: 118px;
    align-items: normal;    
    flex-direction: column;
  }
}
</style>
